import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { getOnboarding30WelcomePageUrl } from '$src/utils/RapidSolutionsIntegrations/urls';
import { redirectToURL } from '$src/utils/redirect';
import LoadingFallback from '$src/components/LocationsSelector/LoadingFallback';
import { useOnboarding30Status } from './hooks';

export function withOnboarding30Redirect(WrappedComponent) {
  return observer((props) => {
    const res = useOnboarding30Status();
    const { isLoading, isFeatureActive } = res;
    const [error, setError] = useState(null);
    const shouldRedirectToOnboarding30WelcomePage = isFeatureActive;

    if (error) {
      throw error;
    }

    useEffect(() => {
      if (shouldRedirectToOnboarding30WelcomePage) {
        const onboardingLocationId = props.location?.pathname.match(/\/onboarding\/(.*)/)?.[1];
        redirectToURL(getOnboarding30WelcomePageUrl(onboardingLocationId));
      }
    }, [setError, shouldRedirectToOnboarding30WelcomePage, props.location?.pathname]);

    if (isLoading || shouldRedirectToOnboarding30WelcomePage) {
      return <LoadingFallback />;
    }

    return <WrappedComponent {...props} />;
  });
}
